"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SSES3 = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=_SSES3.js.map